module.exports = __webpack_public_path__ + "img/landing-invest-banner-mark-mini.aa07d11c.svg";